var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { unwrapCompanyMediaApiData } from "./response";
const GET_SET_COMPANY_MEDIA_ASSETS = "api/company-media/assets";
export const getAssets = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
                params,
            };
            const response = yield this.axiosInstance.get(GET_SET_COMPANY_MEDIA_ASSETS, config);
            return unwrapCompanyMediaApiData(response).assets;
        }
        catch (error) {
            console.error("Error fetching company media assets:", error);
            throw error;
        }
    });
};
